import { j as t } from "./jsx-runtime-3tyXYecC.mjs";
import o from "react";
import { f as m } from "./index-LyFokDcn.mjs";
import { m as i } from "./tss-DN0acMKN.mjs";
import { F as c } from "./form-note-CbSVsgBQ.mjs";
import { L as d } from "./label-BgzuHADZ.mjs";
import { S as p } from "./Stack-BsxljEnZ.mjs";
const f = i({ name: "GroupLegend" })(({ spacing: s }, { hasNote: e }) => ({
  legendContainer: {
    marginBottom: m.ifFeature("encore", s(1.5), e ? 8 : 6)
  }
})), G = ({ id: s, label: e, note: r }) => {
  const { classes: n } = f({ hasNote: !!r }), a = () => {
    if (r)
      return o.isValidElement(r) ? r : /* @__PURE__ */ t.jsx(c, { children: r });
  };
  return /* @__PURE__ */ t.jsx("legend", { id: s, children: /* @__PURE__ */ t.jsxs(p, { className: n.legendContainer, justifyContent: "start", spacing: "2px", children: [
    o.isValidElement(e) ? e : /* @__PURE__ */ t.jsx(d, { children: e }),
    a()
  ] }) });
};
export {
  G
};
//# sourceMappingURL=group-legend-1Z-tEAIm.mjs.map
